import './MainContainer.css';
import { useLocation } from "react-router-dom";
import { useState, useEffect } from 'react';
import Book from "./Book.js"
import DownloadBook from "./DownloadBook.js";
import BrowserView from "./BrowserView.js";
import { getTouchCodenew } from "./func/bookend-api.js";

function MainContainer(props) {
 const pathparam = useLocation().pathname.substring(1).split('/');
 var code = "";
 var project = "";
 if (pathparam.length === 1) {
  code = pathparam[0];
 } else {
  project = pathparam[0];
  code = pathparam[1];
 }
 //const search = useLocation().search;
 //const query = new URLSearchParams(search);
 //const code = query.get('code');
 const [projectInfo, setProjectInfo] = useState(null);
 const [isInvalid, setIsInvalid] = useState(false);
 const [errorMessage, setErrorMessage] = useState("");

 useEffect(() => {
  getTouchCodenew(code, project, getCodeInfo);
 }, [code, project]); // projectも依存配列に追加

 // レンダリングするコンポーネントを決定する関数
 const renderBookComponent = () => {
  if (!projectInfo) {
   return "loading..."; // or a loading spinner
  }

  // ProjectTypeに応じてコンポーネントを切り替え
  switch (parseInt(projectInfo.ProjectType, 10)) {
   case 0:
    return <DownloadBook cInfo={projectInfo} code={code} project={project} isInvalid={isInvalid} errorMessage={errorMessage}/>;
   case 1:
    return <BrowserView cInfo={projectInfo} code={code} project={project}/>;
   case 2:
    return <Book cInfo={projectInfo} code={code} project={project} isInvalid={isInvalid} errorMessage={errorMessage}/>;
   default:
    return `Unsupported ProjectType: ${projectInfo.ProjectType}`;
  }
 };

 return (
  <div className="container">
   {renderBookComponent()}
  </div>
 );

 function getCodeInfo(data) {
  if (data && data.pjinfo) {
   if(data.error){
      setIsInvalid(data.error);
      setErrorMessage(data.message);
   }
   setProjectInfo(data.pjinfo);
  }
 }
}

export default MainContainer;